/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_Token_Warning_Blocked_TitleInputs */

const en_shared_token_warning_blocked_title = /** @type {(inputs: Shared_Token_Warning_Blocked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocked token`)
};

const de_shared_token_warning_blocked_title = /** @type {(inputs: Shared_Token_Warning_Blocked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesperrter Token`)
};

const pt_br2_shared_token_warning_blocked_title = /** @type {(inputs: Shared_Token_Warning_Blocked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token bloqueado`)
};

const tr_shared_token_warning_blocked_title = /** @type {(inputs: Shared_Token_Warning_Blocked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engellenen token`)
};

const zh_cn2_shared_token_warning_blocked_title = /** @type {(inputs: Shared_Token_Warning_Blocked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已屏蔽的代币`)
};

const zh_hk2_shared_token_warning_blocked_title = /** @type {(inputs: Shared_Token_Warning_Blocked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已封鎖代幣`)
};

const ko_kr2_shared_token_warning_blocked_title = /** @type {(inputs: Shared_Token_Warning_Blocked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`차단된 토큰`)
};

const ru_ru2_shared_token_warning_blocked_title = /** @type {(inputs: Shared_Token_Warning_Blocked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заблокированный токен`)
};

const es_419_shared_token_warning_blocked_title = /** @type {(inputs: Shared_Token_Warning_Blocked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token bloqueado`)
};

/**
* | output |
* | --- |
* | "Blocked token" |
*
* @param {Shared_Token_Warning_Blocked_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const shared_token_warning_blocked_title = /** @type {((inputs?: Shared_Token_Warning_Blocked_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_Token_Warning_Blocked_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_token_warning_blocked_title(inputs)
	if (locale === "de") return de_shared_token_warning_blocked_title(inputs)
	if (locale === "pt-BR") return pt_br2_shared_token_warning_blocked_title(inputs)
	if (locale === "tr") return tr_shared_token_warning_blocked_title(inputs)
	if (locale === "zh-CN") return zh_cn2_shared_token_warning_blocked_title(inputs)
	if (locale === "zh-HK") return zh_hk2_shared_token_warning_blocked_title(inputs)
	if (locale === "ko-KR") return ko_kr2_shared_token_warning_blocked_title(inputs)
	if (locale === "ru-RU") return ru_ru2_shared_token_warning_blocked_title(inputs)
	return es_419_shared_token_warning_blocked_title(inputs)
});